const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
  
function getRandomIndex(max){
  const number = Math.random() * max;
  return Math.floor(number);
}

function toRandomChar(){
  const index = getRandomIndex(chars.length);
  return chars.charAt(index);
}

export function generateRandomBase32(length = 16) {
  const arr = Array(length).fill('');
  return arr
    .map(toRandomChar)
    .join('')
};

export function base32tohex(base32) {
  var bits = "";
  var hex = "";

  for (var i = 0; i < base32.length; i++) {
      var val = chars.indexOf(base32.charAt(i).toUpperCase());
      bits += leftpad(val.toString(2), 5, '0');
  }

  for (var i = 0; i+4 <= bits.length; i+=4) {
      var chunk = bits.substr(i, 4);
      hex = hex + parseInt(chunk, 2).toString(16) ;
  }
  return hex.toUpperCase();
}

function leftpad(str, len, pad) {
  if (len + 1 >= str.length) {
      str = Array(len + 1 - str.length).join(pad) + str;
  }
  return str;
}



// WEBPACK FOOTER //
// ./src/util/base32-helper.js